import { useEffect, useRef, useState } from "react";

// Mobile: one swipeable row (85 % cards, snap, dots). Desktop: equal-width grid, no swipe.
export const SwipeRow = ({ items, render, getKey, testId, cols = "md:grid-cols-3", label }) => {
  const ref = useRef(null);
  const [active, setActive] = useState(0);
  useEffect(() => {
    const el = ref.current;
    const onScroll = () => {
      const first = el.children[0];
      if (!first) return;
      const step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(el).columnGap || 0);
      setActive(Math.min(items.length - 1, Math.round(el.scrollLeft / step)));
    };
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [items.length]);
  const goTo = (i) => {
    const el = ref.current;
    el.scrollTo({ left: el.children[i].offsetLeft - el.children[0].offsetLeft, behavior: "smooth" });
  };
  return (
    <div data-testid={testId}>
      <div ref={ref} role="list" aria-label={label}
        className={`flex snap-x snap-mandatory gap-4 overflow-x-auto overscroll-x-contain pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:grid md:gap-6 md:overflow-visible md:pb-0 lg:gap-8 ${cols}`}>
        {items.map((it, i) => (
          <div key={getKey(it)} role="listitem" className="w-[85%] shrink-0 snap-start md:w-auto">{render(it, i)}</div>
        ))}
      </div>
      <div className="mt-3 flex justify-center md:hidden">
        {items.map((it, i) => (
          <button key={getKey(it)} type="button" aria-label={`Ir a la tarjeta ${i + 1}`} aria-current={active === i} data-testid={`${testId}-dot-${i}`} onClick={() => goTo(i)}
            className="grid h-8 min-w-8 place-items-center px-1">
            <span className={`block h-2 rounded-full transition-[width,background-color] duration-300 ${active === i ? "w-6 bg-[#B18A4B]" : "w-2 bg-[#080808]/20"}`} />
          </button>
        ))}
      </div>
    </div>
  );
};
